import { Navigate, useLocation } from "react-router-dom";
import type { FCWithChildren } from "../../api-client/resources/types/sharedTypes";
import { useAuthentication } from "../AuthenticationProvider";
import { UserAccessGuard } from "./UserAccessGuard/UserAccessGuard";

const Authenticated: FCWithChildren = ({ children }) => {
	const location = useLocation();
	const { loggedIn } = useAuthentication();

	if (!loggedIn) {
		return <Navigate to="/" state={{ from: location }} />;
	}

	return <UserAccessGuard>{children}</UserAccessGuard>;
};

export { Authenticated };
